import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetAllUsersByLocation } from 'domain/usecases/user/get-all-users';
import { RemoteGetAllUsers } from 'data/usecases/user/remote-get-all-users';

export const makeGetAllUsers = (): GetAllUsersByLocation => {
  return new RemoteGetAllUsers(makeApiUrl(`/users/all`), makeAuthorizeHttpClientDecorator());
};
